import { InventoryCategory } from '../models/InventoryCategory';
import { InventoryLine } from '../models/InventoryLine';
import { InventoryRecap } from '../models/InventoryRecap';

export class InventoryMapper {
  mapGQLModel(data: any): InventoryRecap | null {
    if (!data) return null;

    const algorithms = this.mapGQLCategory(data?.algorithms);
    const keys = this.mapGQLCategory(data?.keys);
    const keystores = this.mapGQLCategory(data?.keystores);
    const operations = this.mapGQLCategory(data?.operations);

    return new InventoryRecap(algorithms, keys, keystores, operations);
  }

  private mapGQLCategory(entry: any): InventoryCategory[] {
    if (!entry) {
      return [];
    }
    return entry
      .map((e: any) => {
        const lines = [];
        for (const line of e.lines || []) {
          if (!line || !line.count) continue;
          // The backend response can contain non-numeric values such as
          // `<0.1%`, `>99%` and `-` that would become `NaN` when processed
          // with `parseFloat`
          let percentage = null;
          if (line.percentage === '<0.1%') {
            percentage = 0.1;
          } else if (line.percentage === '>99%') {
            percentage = 99;
          } else if (line.percentage !== '-') {
            percentage = parseFloat(line.percentage.replace('%', ''));
          }
          lines.push(new InventoryLine(line.name, line.count, percentage));
        }
        return new InventoryCategory(e.name, lines);
      })
      .filter((c: InventoryCategory) => c.getLines().length > 0);
  }
}
